import { createAction, props } from '@ngrx/store';
import { CheckinSelectState } from './checkin-select.state';
import { DetailsOpenStatus } from '../../interface';

/** StateDetailsActions */
const ACTION_SET = '[CheckinSelect] set';
const ACTION_UPDATE = '[CheckinSelect] update';
const ACTION_RESET = '[CheckinSelect] reset';

/** 以下手動定義アクション */
const ACTION_UPDATE_VIEW_DETAILS_OPEN_STATUS = '[CheckinSelect] update view details open status';

/**
 * Clear the current store object and replace it with the new one
 */
export const setCheckinSelect = createAction(ACTION_SET, props<CheckinSelectState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateCheckinSelect = createAction(ACTION_UPDATE, props<Partial<CheckinSelectState>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetCheckinSelect = createAction(ACTION_RESET);

/**
 * ViewDetailsボタンの開閉状態の更新を行うアクション
 */
export const updateViewDetailsOpenStatus = createAction(
  ACTION_UPDATE_VIEW_DETAILS_OPEN_STATUS,
  props<DetailsOpenStatus>()
);
